import { Injectable } from '@angular/core';
import { CreateEffectMetadata } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { SciGuaduaHttpRequestHandler } from '@scifamek/guadua';
import { Observable } from 'rxjs';
import { createEntityEffects } from '../../../shared/base';
import {
  CreateVendorCommand,
  UpdateVendorCommand,
  GetAllVendorsCommand,
  GetVendorByDocumentCommand,
  UpdateStateVendorCommand,
} from './vendor.commands';
import {
  CreatedVendorEvent,
  UpdatedVendorEvent,
  GotAllVendorsEvent,
  GotVendorByDocumentEvent,
  UpdatedStateVendorEvent,
} from './vendor.events';

@Injectable()
export class VendorEffects {
  prefix = 'vendor';
  createVendorCommand: Observable<Action<string>> & CreateEffectMetadata;
  updateVendorCommand: Observable<Action<string>> & CreateEffectMetadata;
  getAllVendorsCommand: Observable<Action<string>> & CreateEffectMetadata;
  getVendorByDocumentCommand: Observable<Action<string>> & CreateEffectMetadata;
  updateStateVendorCommand: Observable<Action<string>> & CreateEffectMetadata;

  constructor(private sciGuaduaHttpRequestHandler: SciGuaduaHttpRequestHandler) {
    this.createVendorCommand = createEntityEffects(
      sciGuaduaHttpRequestHandler,
      CreateVendorCommand,
      CreatedVendorEvent,
      this.prefix,
    );
    this.updateVendorCommand = createEntityEffects(
      sciGuaduaHttpRequestHandler,
      UpdateVendorCommand,
      UpdatedVendorEvent,
      this.prefix,
    );
    this.getAllVendorsCommand = createEntityEffects(
      sciGuaduaHttpRequestHandler,
      GetAllVendorsCommand,
      GotAllVendorsEvent,
      this.prefix,
    );
    this.getVendorByDocumentCommand = createEntityEffects(
      sciGuaduaHttpRequestHandler,
      GetVendorByDocumentCommand,
      GotVendorByDocumentEvent,
      this.prefix,
    );
    this.updateStateVendorCommand = createEntityEffects(
      sciGuaduaHttpRequestHandler,
      UpdateStateVendorCommand,
      UpdatedStateVendorEvent,
      this.prefix,
    );
  }
}
